import { DashInstance, catchError } from '@/store'
import { isTestAccount } from '@/enums/environment.enum'

const recipients = {
  state: {
    recipients: { items: [], pagination: {} },
    loadingList: true,
    recipientDetail: '',
    hasLocked: false
  },
  getters: {
    recipients (state) {
      return state.recipients
    },
    hasLocked (state) {
      return state.hasLocked
    },
    loadingListRecipients (state) {
      return state.loadingList
    }
  },
  mutations: {
    toggleLoadingList (state, status) {
      state.loadingList = status
    },
    SET_RECIPIENTS (state, recipients) {
      state.recipients = recipients
    },
    SET_RECIPIENT_DETAIL (state, detail) {
      state.recipientDetail = detail
    },
    SET_LOCKED (state, locked) {
      state.hasLocked = locked
    }
  },
  actions: {
    UPDATE_RECIPIENT_GENERAL_SETTINGS (context, params) {
      return DashInstance.recipients
        .updateGeneralSettings(
          params.merchantId,
          params.accountId,
          params.recipientId,
          params.body
        )
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(err => {
          return catchError(err, context)
        })
    },
    UPDATE_RECIPIENT_REGISTER_INFORMATION (context, params) {
      return DashInstance.recipients
        .updateRegisterInformation(
          params.merchantId,
          params.accountId,
          params.recipientId,
          params.body
        )
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(err => {
          return catchError(err, context)
        })
    },
    UPDATE_RECIPIENT_DEFAULT_BANK_ACCOUNT (context, params) {
      return DashInstance.recipients
        .updateDefaultBankAccount(
          params.merchantId,
          params.accountId,
          params.recipientId,
          params.body
        )
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(err => {
          return catchError(err, context)
        })
    },
    UPDATE_RECIPIENT_ANTICIPATION_SETTINGS (context, params) {
      return DashInstance.recipients
        .updateAutomaticAnticipationSettings(
          params.merchantId,
          params.accountId,
          params.recipientId,
          params.body
        )
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(err => {
          return catchError(err, context)
        })
    },
    UPDATE_RECIPIENT_TRANSFER_SETTINGS (context, params) {
      return DashInstance.recipients
        .updateTransferSettings(
          params.merchantId,
          params.accountId,
          params.recipientId,
          params.body
        )
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(err => {
          return catchError(err, context)
        })
    },
    GET_RECIPIENTS (context, params = {}) {
      context.commit('toggleLoadingList', true)
      params.query = {
        ...params.query,
        is_test_account: isTestAccount(
          context.rootGetters.account.account_type.value
        )
      }
      return DashInstance.recipients
        .getAll(params.merchantId, params.accountId, params.query)
        .then(res => {
          context.commit('toggleLoadingList', false)
          context.commit('SET_RECIPIENTS', res)
          return Promise.resolve(res)
        })
        .catch(err => {
          if (err.status === 423) {
            context.commit('toggleLoadingList', false)
            context.commit('SET_LOCKED', true)
          } else {
            return catchError(err, context)
          }
        })
    },
    GET_RECIPIENT_DETAIL (context, data = {}) {
      return DashInstance.recipients
        .getById(data.merchantId, data.accountId, data.recipientId)
        .then(res => Promise.resolve(res))
        .catch(err => {
          return catchError(err, context)
        })
    },

    CREATE_RECIPIENT (context, params = {}) {
      return DashInstance.recipients
        .create(params.query.merchant_id, params.query.account_id, params.body)
        .then(res => Promise.resolve(res))
        .catch(err => {
          return catchError(err, context)
        })
    },
    GENERATE_RECIPIENT_KYC_LINK (context, params = {}) {
      return DashInstance.recipients.generateRecipientKycLink(
        params.merchantId,
        params.accountId,
        params.recipientId
      )
    },
    CREATE_RECIPIENT_V2 (context, params = {}) {
      return DashInstance.recipients
        .createV2(
          params.query.merchant_id,
          params.query.account_id,
          params.body
        )
        .then(res => Promise.resolve(res))
        .catch(err => {
          return catchError(err, context)
        })
    }
  }
}

export default recipients
